import Animation from 'animation'
import * as d3 from 'd3-selection'
import * as shapes from '../shape-util'
import * as scale from 'd3-scale'
import * as colors from 'colors'

class SpikeMapBasicAnimation extends Animation {

  match (serie) {
    return serie.type === 'spike-map'
  }

  bindAndAnimate (container, node) {
    let nodes = this.chart.datum().axes.map.node
      , dimensions = this.chart.datum().dimensions
      , map = container.selectAll('g.map:first-child').selection()
      , projection = map.datum().projection
      , serie = d3.select(node).datum()
      , series = this.series
      , width = 8 // TODO Is this static or based on chart dimensions?
      , linear = scale.scaleLinear().domain(this.scalers.y.left.domain())
                                    .range([.01, dimensions.height * .1])

    d3.select(map.node().ownerSVGElement)
      .select('defs')
      .call(shapes.spikeGradient, serie.color, this.chart.defaultTransition)

    let spike = series.selection()
                      .selectAll('path.spike')
                      .data(d => {
                        return d.points.map(point => {
                          let [x, y] = projection(point.centroid)
                          return Object.assign({}, point, {
                            x, y,
                            height: linear(point.raw)
                          })
                        })
                      })
      , enter = spike.enter()
                     .append('path')
                       .attr('class', 'spike')

    spike.merge(enter)
         .attr('fill', d => `url(#spike-gradient-${serie.color})`)
         .style('stroke', colors.lookup(serie.color))
         .attr('d', d => shapes.spike(width, d.height))
         .attr('transform', d => `translate(${d.x}, ${d.y})`)
         .sort((a, b) => b.height - a.height)

    spike.exit().remove()
  }

}

export default SpikeMapBasicAnimation

export function legend (chart, {width, height}) {
  let margin = chart.datum().dimensions.margin
    , dim = {
      height: height - margin.top - margin.bottom
    }

  // Spike layout will always be vertical. The width of the spike
  // should match the the actual spike width on the map
  let spikeWidth = 8 // TODO should match actual spike width
    , tickWidth = spikeWidth + (spikeWidth * 2) // 12px padding around each spike
    , outerPadding = margin.left + margin.right
    , numTicks = Math.floor((width - outerPadding) / tickWidth)
    , labelHeight = 10 // TODO
    , serieColors = chart.datum().plots[0].series.filter(serie => serie.type == 'spike-map').map(serie => serie.color)
    , color = serieColors.length === 1 ? serieColors[0] : 'gray-dark'
    , ticks = scale.scaleLinear().domain(chart._scalers.y.left.domain())
                                 .range([0, width])
                                 .nice(true)
                                 .ticks(numTicks)
                                 .slice(1)
    , widthScale = scale.scalePoint()
                        .domain(ticks)
                        .range([0, width - outerPadding])
    , heightScale = scale.scaleLinear()
                         .domain([0, ticks[ticks.length - 1]])
                         .range([0, dim.height - labelHeight])

  let legend = d3.create('svg')
                 .attr('class', `spike-legend ${color}`)
                 .attr('width', width)
                 .attr('height', height)

    , tick = legend.append('g')
                   .attr('transform', `translate(${margin.left}, ${margin.top})`)
                   .selectAll('g.tick')
                   .data(ticks)
                   .join('g')
                     .attr('class', 'tick')
                     .attr('transform', (d, i) => {
                       return `translate(${widthScale(d)}, ${dim.height - labelHeight})`
                     })

  legend.append('defs')
        .call(shapes.spikeGradient, color)

  tick.append('path')
      .attr('fill', d => `url(#spike-gradient-${color})`)
      .attr('d', d => shapes.spike(spikeWidth, heightScale(d)))
      .style('stroke', colors.lookup(color))

  tick.append('text')
      .attr('dy', '1em')
      .text(heightScale.tickFormat(4, 's'))

  return legend.node()
}
